module.exports = __webpack_public_path__ + "img/EXTERIOR-CIAZ-3.6f8533ec.jpg";